import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PaymentLookup from "./pages/PaymentLookup";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PaymentLookup />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
